import React from "react";
import { Box } from "@mui/material";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import AppleIcon from "@mui/icons-material/Apple";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { C, FOCUS_RING, FONT_BODY, VISUALLY_HIDDEN } from "../../../utils/designTokens";

export const STORES = [
  { href: "https://apps.apple.com/us/app/rushmyfood/id1573433295", small: "Download on the", big: "App Store", Icon: AppleIcon },
  { href: "https://play.google.com/store/apps/details?id=io.appbuild.rushmyfo", small: "Get it on", big: "Google Play", Icon: PlayArrowRoundedIcon },
];

/** "Track every order on the go": a small strip with the two store buttons. */
function AppPromo() {
  return (
    <Box
      component="aside"
      aria-label="Get the RushMyFood app"
      sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "flex-start", sm: "center" }, gap: 2, p: { xs: "18px", sm: "18px 22px" }, borderRadius: "22px", bgcolor: C.surface }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.75, flex: 1, minWidth: 0 }}>
        <Box aria-hidden="true" sx={{ width: 48, height: 48, flexShrink: 0, borderRadius: "14px", bgcolor: C.redTint, color: C.red, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <PhoneIphoneRoundedIcon sx={{ fontSize: 26 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Box sx={{ fontFamily: FONT_BODY, fontSize: 16, fontWeight: 700, color: C.ink }}>Track every order on the go</Box>
          <Box sx={{ fontFamily: FONT_BODY, fontSize: 14, color: C.muted, mt: 0.25 }}>Get the RushMyFood app for live updates and faster reorders.</Box>
        </Box>
      </Box>
      <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
        {STORES.map(({ href, small, big, Icon }) => (
          <Box
            key={big}
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ ...FOCUS_RING, display: "inline-flex", alignItems: "center", gap: 0.75, height: 44, px: 1.5, borderRadius: "10px", bgcolor: C.ink, color: "#FFFFFF", textDecoration: "none", "&:hover": { bgcolor: "#000000" } }}
          >
            <Icon aria-hidden="true" sx={{ fontSize: 24 }} />
            <Box component="span" sx={{ display: "flex", flexDirection: "column", lineHeight: 1.05, fontFamily: FONT_BODY }}>
              <Box component="span" sx={{ fontSize: 10, fontWeight: 500 }}>{small}</Box>
              <Box component="span" sx={{ fontSize: 15, fontWeight: 700 }}>{big}</Box>
            </Box>
            <Box component="span" sx={VISUALLY_HIDDEN}> (opens in a new tab)</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default AppPromo;
